import React, { useEffect, useState } from "react";
import AppStore from "../../config/AppStore";
import { useNavigate, useParams } from "react-router-dom";
import ModalComponent from "../../components/common/Modal";
import { sendApprovedPublisherRequest } from "../../view_logics/Publishers";
import { Modal } from 'bootstrap';

const PublishersApprovedModel = ({ publisherId, isVisible, onApproved }) => {
    const [reportsFilterLoading, setReportsFilterLoading] = useState(false);
    const [approving, setApproving] = useState(false);

    const [publisherFormLoading, setPublisherFormLoading] = useState(false);


    let store = AppStore.getAppStoreInstance();
    let accessToken = store.getState().login.accessToken;

    const navigate = useNavigate();

    const handleApprove = async () => {
        setApproving(true);
        try {
            // TODO: Add your API call or logic here
            //console.log("Approving publisher with ID:", publisherId);

            const inputObj = {
                accessToken: accessToken,
                url: "/publishers",
                history: navigate,
                dataToPost: { publisher_id: publisherId },
                loadingHandler: setPublisherFormLoading,
            };
            setPublisherFormLoading(true);
            //sendApprovedPublisherRequest(inputObj);
            const res = await sendApprovedPublisherRequest(inputObj);

            // ✅ notify parent
            if (res?.status === "success") {
                onApproved(publisherId); // 👈 this triggers parent's fetchPublishersList
            }

        } catch (error) {
            console.error("Approval failed:", error);
            setApproving(false);
        }
    };

    return (
        <>
            <ModalComponent
                id={"publishers_approved_model"}
                size={"modal-sm"}
                modalHeading={" "}
                saveHandler={() => handleApprove() }
            >
                <div className="text-center p-3">
                    <h5>Do you want to approve this publisher?</h5>
                    <p className="text-muted">Publisher ID: {publisherId}</p>
                    {/* <div className="d-flex justify-content-center gap-2 mt-4">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleApprove}
                            disabled={approving}
                        >
                            {approving ? "Approving..." : "Approve"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                            disabled={approving}
                        >
                            Cancel
                        </button>
                    </div> */}
                </div>
            </ModalComponent>

        </>
    );
};

export default PublishersApprovedModel;
